import { useMutation, useQueryClient } from '@tanstack/react-query';

import { pushApi } from '../api/push-api';

import { pushKeys } from './push-keys';

/** Stops pushes to another of the member's browsers (an old phone, a shared laptop). */
export function useRemovePushDevice() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => pushApi.remove(id),
    meta: { successMessage: 'push:toasts.removed' },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: pushKeys.settings() }),
  });
}
